import {
  Dialog as DialogTypes,
  Step as StepTypes,
  Email as EmailTypes,
  Phone as PhoneTypes,
  Address as AddressTypes,
} from './types'

export class Dialog {
  static show() {
    return {type: DialogTypes.SHOW}
  }

  static hide() {
    return {type: DialogTypes.HIDE}
  }
}

export class Step {

  static goToStep(step) {
    return {
      type: StepTypes.GO_TO_STEP,
      step,
    }
  }

  static goBack() {
    return function(dispatch, getState) {

      switch (getState().firstLogin.step) {
        case 1:
          dispatch(Phone.cancelCheckNumber())
          dispatch(Phone.cancelCheckCode())
          break
        case 2:
          dispatch(Address.cancelAddressCheck())
          break
        default:
      }

      return dispatch({type: StepTypes.GO_BACK})
    }
  }


}

export class Email {

  static checkEmail(email) {
    return function(dispatch, getState) {

      dispatch({type: EmailTypes.START_EMAIL_CHECK})

      return new Promise(function(resolve) {
        setTimeout(resolve, 2000)
      })
        .then(
          response => {
            if (getState().firstLogin.email.isCancelled === false) {
              dispatch(Email.receiveEmailCheck(''))
              dispatch(Step.goToStep(1))
            }
          },
          err => {
            if (getState().firstLogin.email.isCancelled === false) {
              console.log(err)
              dispatch(Email.receiveEmailCheck(err.message))
            }
          },
        )
    }
  }

  static cancelEmailCheck() {
    return {
      type: EmailTypes.CANCEL_EMAIL_CHECK,
    }
  }

  static receiveEmailCheck(error) {
    return {
      type: EmailTypes.RECEIVE_EMAIL_CHECK,
      error,
    }
  }
}

export class Phone {

  static checkNumber(number) {
    return function(dispatch, getState) {

      dispatch({type: PhoneTypes.CHECK_NUMBER})

      return new Promise(function(resolve) {
        setTimeout(resolve, 1000)
      })
        .then(
          response => {
            if (getState().firstLogin.phone.isCheckingNumberCancelled === false) {
              dispatch(Phone.receiveCheckNumber(''))
              dispatch(Phone.openSMSCodeDialog())
            }
          },
          err => {
            if (getState().firstLogin.phone.isCheckingNumberCancelled === false) {
              console.log(err)
              dispatch(Phone.receiveCheckNumber(err.message))
            }
          },
        )
    }
  }

  static cancelCheckNumber() {
    return {
      type: PhoneTypes.CANCEL_CHECK_NUMBER,
    }
  }

  static receiveCheckNumber(error) {
    return {
      type: PhoneTypes.RECEIVE_CHECK_NUMBER,
      error,
    }
  }

  static openSMSCodeDialog() {
    return {
      type: PhoneTypes.OPEN_SMS_CODE_DIALOG,
      showDialog: true,
    }
  }

  static closeSMSCodeDialog() {
    return {
      type: PhoneTypes.CLOSE_SMS_CODE_DIALOG,
      showDialog: false,
    }
  }

  static checkCode(code) {
    return function(dispatch, getState) {

      dispatch({type: PhoneTypes.CHECK_CODE})

      return new Promise(function(resolve) {
        setTimeout(resolve, 1000)
      })
        .then(
          response => {
            if (getState().firstLogin.phone.isCheckingCodeCancelled === false) {
              dispatch(Phone.receiveCodeCheck(''))
              dispatch(Phone.closeSMSCodeDialog())
              dispatch(Step.goToStep(2))
            }
          },
          err => {
            if (getState().firstLogin.email.isCheckingCodeCancelled === false) {
              console.log(err)
              dispatch(Phone.receiveCodeCheck(err.message))
            }
          },
        )
    }
  }

  static cancelCheckCode() {
    return {
      type: PhoneTypes.CANCEL_CHECK_CODE,
    }
  }

  static receiveCodeCheck(error) {
    return {
      type: PhoneTypes.RECEIVE_CODE_CHECK,
      error,
    }
  }
}

export class Address {

  static checkAddress(address, number) {
    return function(dispatch, getState) {

      dispatch({type: AddressTypes.CHECK_ADDRESS})

      return new Promise(function(resolve) {
        setTimeout(resolve, 2000)
      })
        .then(
          response => {
            if (getState().firstLogin.address.isCancelled === false) {
              dispatch(Address.receiveAddressCheck(''))
              dispatch(Dialog.hide())
            }
          },
          err => {
            if (getState().firstLogin.address.isCancelled === false) {
              console.log(err)
              dispatch(Address.receiveAddressCheck(err.message))
            }
          },
        )
    }
  }

  static cancelAddressCheck() {
    return {
      type: AddressTypes.CANCEL_ADDRESS_CHECK,
    }
  }

  static receiveAddressCheck(error) {
    return {
      type: AddressTypes.RECEIVE_ADDRESS_CHECK,
      error,
    }
  }
}



// WEBPACK FOOTER //
// ./src/sections/firstlogin/actions.js